import { useRef, useState } from "react";

export default function OtpInput({ value, onChange, testid = "otp-input" }) {
  const refs = useRef([]);
  const digits = value.padEnd(6, " ").slice(0, 6).split("");

  const setDigit = (i, d) => {
    const clean = d.replace(/\D/g, "");
    const next = (value.slice(0, i) + clean.slice(-1) + value.slice(i + 1)).slice(0, 6);
    onChange(next.replace(/\s/g, ""));
    if (clean && i < 5) refs.current[i + 1]?.focus();
  };

  const onKey = (i, e) => {
    if (e.key === "Backspace" && !digits[i].trim() && i > 0) refs.current[i - 1]?.focus();
  };

  const onPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    onChange(pasted);
    refs.current[Math.min(pasted.length, 5)]?.focus();
  };

  return (
    <div className="flex gap-2 justify-center" data-testid={testid}>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          value={d.trim()}
          inputMode="numeric"
          maxLength={1}
          onChange={(e) => setDigit(i, e.target.value)}
          onKeyDown={(e) => onKey(i, e)}
          onPaste={onPaste}
          data-testid={`otp-digit-${i}`}
          className="w-11 h-13 sm:w-12 sm:h-14 text-center text-xl font-semibold text-[#2E1A22] bg-white border border-[#E5E7EB] rounded-xl outline-none focus:border-[#7E1E3F] focus:shadow-[0_0_0_3px_rgba(126,30,63,0.12)] transition-[border-color,box-shadow] duration-200"
          style={{ height: 52 }}
        />
      ))}
    </div>
  );
}
